module.exports = __webpack_public_path__ + "media/images/emblems/CollongeBellerive-coat_of_arms-3a7fee23dce21cf9c20dd569c2331c3f.svg";